import { Flex } from "antd";
import type { ClientViewRenderProps } from "./ClientViewRender";
import { ClientInfo } from "./Client";
import { TicketsInfo } from "./Tickets";
import { TurbinesInfo } from "./Turbines";
import { ProjectsInfo } from "./Projects";
import type { Dispatch } from "@reduxjs/toolkit";

type ClientInformationProps = ClientViewRenderProps & { dispatch: Dispatch };

export const ClientInformation = (props: ClientInformationProps) => {
  const { intl, clientData, modalApi, currentRoute, dispatch } = props;
  return (
    <Flex vertical gap="middle">
      <ClientInfo
        currentRoute={currentRoute}
        intl={intl}
        clientData={clientData}
        modalApi={modalApi}
      />
      <TurbinesInfo
        currentRoute={currentRoute}
        intl={intl}
        clientData={clientData}
        modalApi={modalApi}
      />
      <TicketsInfo
        currentRoute={currentRoute}
        intl={intl}
        clientData={clientData}
        modalApi={modalApi}
        dispatch={dispatch}
      />
      <ProjectsInfo
        currentRoute={currentRoute}
        intl={intl}
        clientData={clientData}
        modalApi={modalApi}
        dispatch={dispatch}
      />
    </Flex>
  );
};
